//import { CY } from "../js/aisdk.js";
import EnxUtils from "../utils/utils";
const crypto = require("crypto");
("use strict");
export default class EnxFaceAI {
  constructor() {
    this.CY = null;
    this.version = "2.1";
    this.licenceKey = null;
    this.faceAI = null;
    this.enxRoomObj = null;
    this.stopEnxFace = {};
    this.faceUID = null;
    this.isClientUsage = false;
    this.startFaceEvents = [];
    this.stopEnxFaceAI = null;
  }

  async init(roomParams, stream = null, faceConfig = {}, callback) {
    let CY = await EnxUtils.downloadAiSDK();
    this.CY = CY;
    var decipher = crypto.createDecipher(
      "aes-256-cbc",
      roomParams.roomData.conf_num.toString()
    );
    var dec = decipher.update(roomParams.roomData.analyzer, "hex", "utf8");
    dec += decipher.final("utf8");
    this.licenceKey = dec;
    this.enxRoomObj = roomParams.room;
    this.faceUID = Date.now();
    if (this.enxRoomObj && this.licenceKey) {
      this.enxRoomObj.pingBack((data) => {
        if (data.result === 0) {
          const data = {
            idx: this.faceUID,
            tool: "facex",
            method: "FACEX-START",
            stop_after: null,
          };
          if (stream && stream.standAlone) {
            data.stand_alone = true;
          }
          this.enxRoomObj.startClientUsage(data, (data) => {
            if (data.result === 0) {
              this.isClientUsage = true;
              if (stream) {
                const streamID = stream.standAlone
                  ? stream.streamID
                  : "stream" + stream.getID();
                const streamSource = this.CY.createSource.fromVideoElement(
                  document.getElementById(streamID)
                );
                this.faceAI = this.CY.loader()
                  .maxInputFrameSize(640)
                  .licenseKey(this.licenceKey)
                  .source(streamSource);
              } else {
                this.faceAI = this.CY.loader().maxInputFrameSize(640).licenseKey(this.licenceKey);
              }
              this.faceAI
              .addModule(this.CY.modules().FACE_DETECTOR.name, faceConfig.faceDetector || {})
              .addModule(this.CY.modules().FACE_POSE.name, faceConfig.facePose || {})
              .addModule(this.CY.modules().FACE_AGE.name, faceConfig.faceAge || {})
              .addModule(this.CY.modules().FACE_EMOTION.name, faceConfig.faceEmotion || {})
              .addModule(this.CY.modules().FACE_GENDER.name, faceConfig.faceGender || {})
              .addModule(this.CY.modules().FACE_FEATURES.name, faceConfig.faceFeatures || {})
              .addModule(this.CY.modules().FACE_AROUSAL_VALENCE.name, faceConfig.faceArousalValence || {})
              .addModule(this.CY.modules().FACE_ATTENTION.name, faceConfig.faceAttention || {})
              .load()
              .then(({ start, stop }) => {
                this.stopEnxFaceAI = stop;
                start();
                if (!this.isClientUsage) {
                  this.startClientUsage();
                }
              });

            }
            callback(data);
          });
        }
      });
    }
  }

  async initAI(config = {}, callback) {
    const facexObj = this;
    let streamObj = { standAlone: true };
    if (config.containerID) {
      streamObj.streamID = "stream_" + Date.now();
      const constraints = {
        video: config.camID ? { deviceId: config.camID } : true,
      };
      streamObj.stream = await EnxUtils.openMediaDevices(constraints);
      EnxUtils.plotVideo(streamObj, config.containerID);
    } else if (config.streamID) {
      streamObj.streamID = config.streamID;
    } else {
      callback({ result: 1, message: `missing config` });
      return;
    }
    const roomData = await EnxUtils.createRoom(config.serverURL);
    if (roomData.result === 0) {
      const params = {
        name: config.name,
        role: "moderator",
        roomId: roomData.room.room_id,
        user_ref: config.name,
      };
      const tokenData = await EnxUtils.createToken(params, config.serverURL);
      if (tokenData.result === 0) {
        const localStream = EnxRtc.joinRoom(tokenData.token, {}, function (
          response,
          error
        ) {
          if (response && response != null) {
            facexObj.init(response, streamObj, (res) => {
              callback(res);
            });
          } else {
            callback({ result: 101, message: `Connection failed` });
          }
        });
      } else {
        callback({ result: 102, message: `Connection failed` });
      }
    } else {
      callback({ result: 103, message: `Connection failed` });
    }
  }

  /*Function enableFace 
   This function return the following arrays
   faces: An array containing the detected faces in form of ImageData objects (zero or one; or multiple faces, if fullFrameDetection is true)
   rects: An array of objects describing the bounding boxes (zero or one; or multiple rects, if fullFrameDetection is true)
   x: The upper left point x coordinate
   y: The upper left point y coordinate
   width:The width of the bounding box
   height:The height of the bounding box
   status:A string containing the status of the face tracker
   "INIT": Tracker is initializing; zero or many faces could be returned
   "TRACK_OK": Tracker is correctly tracking one face; one face is returned
   "RECOVERING": Tracker has lost a face and is attempting to recover and continue tracking; zero faces are returned
   fullFrameDetection: A boolean. It is true when detection was full-frame and multiple faces can be returned, false otherwise.*/
  startFaceDetector(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-detector"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-detector already started` });
      return;
    }
    this.startFaceEvents.push("face-detector");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_DETECTOR.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_DETECTOR = stop;
    //     start();
    //     this.startFaceEvents.push("face-detector");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-detector started` });
    //   });
    callback({ result: 0, message: `face-detector started` });
    window.addEventListener(
      this.CY.modules().FACE_DETECTOR.eventName,
      (evt) => {
        let faceEvt = new CustomEvent(`face-detector`, {
          detail: evt.detail,
        });
        window.dispatchEvent(faceEvt);
      }
    );
  }
  stopFaceDetector(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-detector"
    );
    this.stopFaceEvt("FACE_DETECTOR", (res) => {
      callback(res);
    });
  }
  /* Function enableFacePose
   This function return the output of pose prediction
   An object containing the output of the pose prediction
   pose: An object containing the filtered (smoothened) pose rotation angles expressed in radiants as pitch, roll and yaw.*/
  startFacePose(callback) {
    const filterEvt = this.startFaceEvents.filter((evt) => evt === "face-pose");
    if (filterEvt.length) {
      callback({ result: 1, message: `face-pose already started` });
      return;
    }
    this.startFaceEvents.push("face-pose");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_POSE.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_POSE = stop;
    //     start();
    //     this.startFaceEvents.push("face-pose");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-pose started` });
    //   });
    callback({ result: 0, message: `face-pose started` });
    window.addEventListener(this.CY.modules().FACE_POSE.eventName, (evt) => {
      let facePoseEvt = new CustomEvent(`face-pose`, {
        detail: evt.detail,
      });
      window.dispatchEvent(facePoseEvt);
    });
  }
  stopFacePose(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-pose"
    );
    this.stopFaceEvt("FACE_POSE", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceAge 
   It returns an object containing the output of the age prediction
   age: An object containing the probabilities of the filtered (smoothened) age prediction:
   _-18: The probability that predicted age is less than 18 years old.
   18-35: The probability that predicted age is greater than or equal to 18 years old and less than 35 years old.
   35-51: The probability that predicted age is greater than or equal to 35 years old and less than 51 years old.
   51-_: The probability that predicted age is greater than or equal to 51 years old.
   numericAge: A numeric estimate for the age
   Note: in case of poor quality of the prediction, the event is not fired (i.e. skipped for that frame).*/
  startFaceAge(callback) {
    const filterEvt = this.startFaceEvents.filter((evt) => evt === "face-age");
    if (filterEvt.length) {
      callback({ result: 1, message: `face-age already started` });
      return;
    }
    this.startFaceEvents.push("face-age");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_AGE.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_AGE = stop;
    //     start();
    //     this.startFaceEvents.push("face-age");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-age started` });
    //   });
    callback({ result: 0, message: `face-age started` });
    window.addEventListener(this.CY.modules().FACE_AGE.eventName, (evt) => {
      let faceAgeEvt = new CustomEvent(`face-age`, {
        detail: evt.detail,
      });
      window.dispatchEvent(faceAgeEvt);
    });
  }
  stopFaceAge(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-age"
    );
    this.stopFaceEvt("FACE_AGE", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceEmotion
   output: An object containing the output of the emotion prediction
   dominantEmotion: the name of the dominant emotion if present, otherwise it is undefined.
   emotion: An object containing the filtered (smoothened) values of the probability distribution of emotions.
   The sum of all the probabilities is always 1, each probability in the distribution has a value between 0 and 1.
   Angry: The probability for Angry.
   Disgust: The probability for Disgust.
   Fear: The probability for Fear.
   Happy: The probability for Happy.
   Sad: The probability for Sad.
   Surprise: The probability for Surprise.
   Neutral: The probability for Neutral.*/
  startFaceEmotion(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-emotion"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-emotion already started` });
      return;
    }
    this.startFaceEvents.push("face-emotion");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_EMOTION.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_EMOTION = stop;
    //     start();
    //     this.startFaceEvents.push("face-emotion");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-emotion started` });
    //   });
    callback({ result: 0, message: `face-emotion started` });
    window.addEventListener(this.CY.modules().FACE_EMOTION.eventName, (evt) => {
      let faceEmotionEvt = new CustomEvent(`face-emotion`, {
        detail: evt.detail,
      });
      window.dispatchEvent(faceEmotionEvt);
    });
  }
  stopFaceEmotion(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-emotion"
    );
    this.stopFaceEvt("FACE_EMOTION", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceGender
   output: An object containing the output of the gender prediction
   gender: An object containing the filtered (smoothened) probabilities of the gender prediction:
   Female: The probability that predicted gender is Female.
   Male: The probability that predicted gender is Male.
   mostConfident: Gender name of the most likely result if its smoothened probability is above the threshold, otherwise it is undefined.*/
  startFaceGender(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-gender"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-gender already started` });
      return;
    }
    this.startFaceEvents.push("face-gender");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_GENDER.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_GENDER = stop;
    //     start();
    //     this.startFaceEvents.push("face-gender");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-gender started` });
    //   });
    callback({ result: 0, message: `face-gender started` });
    window.addEventListener(this.CY.modules().FACE_GENDER.eventName, (evt) => {
      let faceGenderEvt = new CustomEvent(`face-gender`, {
        detail: evt.detail,
      });
      window.dispatchEvent(faceGenderEvt);
    });
  }
  stopFaceGender(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-gender"
    );
    this.stopFaceEvt("FACE_GENDER", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceFeatures
   output: An object containing the output of the face features prediction
   features: An object containing the filtered (smoothened) probabilities of each face independent feature in range [0.0, 1.0]:
   Arched Eyebrows
   Attractive
   Bags Under Eyes
   Bald
   Bangs
   Beard 5 O'Clock Shadow
   Big Lips
   Big Nose
   Black Hair
   Blond Hair
   Brown Hair
   Chubby
   Double Chin
   Earrings
   Eyebrows Bushy
   Eyeglasses
   Goatee
   Gray Hair
   Hat
   Heavy Makeup
   High Cheekbones
   Lipstick
   Mouth Slightly Open
   Mustache
   Narrow Eyes
   Necklace
   Necktie
   No Beard
   Oval Face
   Pale Skin
   Pointy Nose
   Receding Hairline
   Rosy Cheeks
   Sideburns
   Straight Hair
   Wavy Hair*/
  startFaceFeatures(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-features"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-features already started` });
      return;
    }
    this.startFaceEvents.push("face-features");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_FEATURES.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_FEATURES = stop;
    //     start();
    //     this.startFaceEvents.push("face-features");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-features started` });
    //   });
    callback({ result: 0, message: `face-features started` });
    window.addEventListener(
      this.CY.modules().FACE_FEATURES.eventName,
      (evt) => {
        let faceFeaturesEvt = new CustomEvent(`face-features`, {
          detail: evt.detail,
        });
        window.dispatchEvent(faceFeaturesEvt);
      }
    );
  }
  stopFaceFeatures(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-features"
    );
    this.stopFaceEvt("FACE_FEATURES", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceArousalValence
   output: An object containing the output of the face arousal/valence prediction
   arousalvalence: An object containing the filtered (smoothened) values.
   arousal: value in range [-1.0, 1.0]. It represents the degree of engagement (positive arousal), or disengagement (negative arousal).
   valence: value in range [-1.0, 1.0]. It represents the degree of pleasantness (positive valence), or unpleasantness (negative valence).*/
  startFaceArousalValence(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-arousal-valence"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-arousal-valence already started` });
      return;
    }
    this.startFaceEvents.push("face-arousal-valence");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_AROUSAL_VALENCE.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_AROUSAL_VALENCE = stop;
    //     start();
    //     this.startFaceEvents.push("face-arousal-valence");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-arousal-valence started` });
    //   });
    callback({ result: 0, message: `face-arousal-valence started` });
    window.addEventListener(
      this.CY.modules().FACE_AROUSAL_VALENCE.eventName,
      (evt) => {
        let faceArousalValenceEvt = new CustomEvent(`face-arousal-valence`, {
          detail: evt.detail,
        });
        window.dispatchEvent(faceArousalValenceEvt);
      }
    );
  }
  stopFaceArousalValence(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-arousal-valence"
    );
    this.stopFaceEvt("FACE_AROUSAL_VALENCE", (res) => {
      callback(res);
    });
  }
  /*Function enableFaceAttention
   output: An object containing the output of the face attention prediction
   attention: filtered value (smoothened) in range [0.0, 1.0]. A value close to 1.0 represents attention, a value close to 0.0 represents distraction.*/
  startFaceAttention(callback) {
    const filterEvt = this.startFaceEvents.filter(
      (evt) => evt === "face-attention"
    );
    if (filterEvt.length) {
      callback({ result: 1, message: `face-attention already started` });
      return;
    }
    this.startFaceEvents.push("face-attention");
    // this.faceAI
    //   .addModule(this.CY.modules().FACE_ATTENTION.name, config)
    //   .load()
    //   .then(({ start, stop }) => {
    //     this.stopEnxFace.FACE_ATTENTION = stop;
    //     start();
    //     this.startFaceEvents.push("face-attention");
    //     if (!this.isClientUsage) {
    //       this.startClientUsage();
    //     }
    //     callback({ result: 0, message: `face-attention started` });
    //   });
    callback({ result: 0, message: `face-attention started` });
    window.addEventListener(
      this.CY.modules().FACE_ATTENTION.eventName,
      (evt) => {
        let faceAttentionEvt = new CustomEvent(`face-attention`, {
          detail: evt.detail,
        });
        window.dispatchEvent(faceAttentionEvt);
      }
    );
  }
  stopFaceAttention(callback) {
    this.startFaceEvents = this.startFaceEvents.filter(
      (evt) => evt !== "face-attention"
    );
    this.stopFaceEvt("FACE_ATTENTION", (res) => {
      callback(res);
    });
  }


  stopFaceAI(callback){
    setTimeout(this.stopEnxFaceAI, 10);
    this.stopClientUsage(callback);
  }

  stopFaceEvt(name, callback) {
    if (this.startFaceEvents.length === 0) {
      this.stopClientUsage();
    }
    if (this.stopEnxFace[name]) {
      setTimeout(this.stopEnxFace[name], 10);
      callback({ result: 0, message: `${name} stopped` });
    } else {
      callback({ result: 1, message: `${name} not yet started` });
    }
  }

  startClientUsage() {
    const data = {
      idx: this.faceUID,
      tool: "facex",
      method: "FACEX-START",
      stop_after: null,
    };
    this.enxRoomObj.startClientUsage(data, (data) => {
      if (data.result === 0) {
        this.isClientUsage = true;
      }
    });
  }

  stopClientUsage(callback) {
    const data = { idx: this.faceUID, tool: "facex", method: "FACEX_STOP" };
    this.enxRoomObj.stopClientUsage(data, (data) => {
      if (data.result === 0) {
        this.faceUID = Date.now();
        this.isClientUsage = false;
        callback({ result: 0, message: `Face AI stopped` });
      }
    });
  }
}
